exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-info-polizza-assicurativa/dialog-info-polizza-assicurativa.component.css
// module id = ../../../../../src/app/components/utilita/dialogs/dialog-info-polizza-assicurativa/dialog-info-polizza-assicurativa.component.css
// module chunks = main